import { CardTypeEnum } from '../enums/card-type.enum';
import { isCreditCardAmex } from '../utils/card-utils';

const regularCardMask = CardTypeEnum.GENERIC.numberMask;
const amexCardMask = CardTypeEnum.AMEX.numberMask;
const regularOrAmexCardMask = `${regularCardMask}||${amexCardMask}`;

export function CardNumberMask(value: string) {
    const cleanValue = ((value || '').match(/\d/g) || []).join('');

    if (!cleanValue || cleanValue.length < 6) {
        return regularOrAmexCardMask;
    }

    if (isCreditCardAmex(value)) {
        return amexCardMask;
    } else {
        return regularCardMask;
    }
}
